<input
  type="search"
  [placeholder]="placeHolder"
  [(ngModel)]="searchTerm"
  (ngModelChange)="updateSearchTerm($event)"
/>
